export enum EFBDomainInputMode {
  SUBDOMAIN = 'subdomain',
  CUSTOM_DOMAIN = 'custom-domain'
}

export type IFBDomainInputMode = 'subdomain' | 'custom-domain'; // To make TS lint happy it is hardcoded
